import type {ComponentProps} from '@enonic/react-components'
import * as React from 'react'
import {Section, Container} from '../primitives'

export interface PersonLandingData extends Record<string, unknown> {
    title: string
    lead: string
}

export const PersonLanding = (props: ComponentProps) => {
    const data = props.data as PersonLandingData
    const {title, lead} = data

    return (
        <Section>
            <Container className="gap-y-5 md:gap-y-8">
                <h1 className="col-span-full font-serif text-4xl leading-tightest text-blue-900 md:text-7xl">
                    {title}
                </h1>
                {lead && (
                    <p className="col-span-full text-xl text-black md:col-span-8 md:text-3xl">
                        {lead}
                    </p>
                )}
            </Container>
        </Section>
    )
}
